import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "wishlist-page" }
const _hoisted_2 = { class: "wishlist-page__content" }
const _hoisted_3 = {
  key: 0,
  class: "wishlist-page__product-list"
}
const _hoisted_4 = {
  key: 1,
  class: "wishlist-page__content-empty"
}

import { computed, inject } from 'vue';
import { pageKey } from '@drapejs/core';

import { getWishlist } from '@/composables/useWishlist';
import useMeta from '@/composables/useMeta';
import useWebsiteTexts from '@/composables/useWebsiteTexts';

import ProductCard from '@/components/ProductCard';


export default /*#__PURE__*/_defineComponent({
  __name: 'Wishlist',
  setup(__props) {

const page = inject(pageKey);

const { wishlistProducts } = getWishlist();
const { websiteText } = useWebsiteTexts();

useMeta();

const title = computed(() => {
  return page?.value?.fields?._name;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", null, _toDisplayString(_unref(title)), 1),
      (_unref(wishlistProducts).length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(wishlistProducts), (product) => {
              return (_openBlock(), _createBlock(_unref(ProductCard), {
                key: product.articleNumber,
                hideRelatedArticles: true,
                hideFavouriteIcon: true,
                hideColorSwatches: true,
                hideSizeRange: true,
                disableHover: true,
                showRemoveFromWishlistButton: true,
                canAddToCart: true,
                class: "wishlist-page__product-list-item",
                product: product
              }, null, 8, ["product"]))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_unref(websiteText)('wishlist__empty').value), 1))
    ])
  ]))
}
}

})